<template>
  <div id="app">
    <ui-toolbar
      id="toolbar"
      :brand="width >= 600 ? 'Brickfinder' : ''"
      :title="title"
      :loading="this.$root.loading>0"
      @nav-icon-click="menu = !menu"
    >
      <div slot="actions">
        <ui-icon-button
          icon="arrow_back"
          type="secondary"
          v-if="this.$route.meta.parent"
          @click="backSubmit"
        />
        <ui-icon-button
          icon="add"
          type="secondary"
          v-if="this.$route.name == 'Sets'"
          has-dropdown
          ref="add"
          @dropdown-open="menuBlur"
        >
          <ui-textbox
            slot="dropdown"
            autofocus
            icon="add"
            type="number"
            placeholder="Set Number"
            @keydown-enter="addSubmit"
            @blur="addBlur"
            v-model="add_input"
            :invalid="add_invalid"
            :error="add_error"
            :disabled="add_disabled"
          ></ui-textbox>
        </ui-icon-button>
        <ui-icon-button
          icon="sort"
          type="secondary"
          size="large"
          v-if="this.$route.meta.sort_menu"
          has-dropdown
          ref="sort"
          @dropdown-open="menuBlur"
        >
          <ui-menu
            contain-focus
            :options="sortOptions"
            @select="sortSubmit"
            @close="$refs.sort.closeDropdown()"
            slot="dropdown"
          ></ui-menu>
        </ui-icon-button>
        <ui-icon-button
          icon="search"
          type="secondary"
          v-if="this.$route.name != 'Login'"
          has-dropdown
          ref="search"
          @dropdown-open="menuBlur"
        >
          <ui-textbox
            slot="dropdown"
            icon="search"
            type="search"
            placeholder="Search"
            @keydown-enter="searchSubmit"
            @blur="searchBlur"
            v-model="search_input"
            :error="search_error"
          ></ui-textbox>
        </ui-icon-button>
      </div>
    </ui-toolbar>
    <transition name="slide">
      <ui-menu
        id="menu"
        v-if="menu"
        has-icons
        :options="menuOptions"
        style="height:100%"
        @select="menuSelect"
        @close="menuBlur"
      ></ui-menu>
    </transition>
    <router-view
      :sort="sort_input[this.$route.name]"
      :sets="this.$root.sets"
      :set="this.$root.sets[this.$route.params.set]"
      :search="search_input"
    />

    <ui-confirm
      autofocus="none"
      ref="confirmComplete"
      title="Complete Set"
      @confirm="actionComplete"
    >
      This will set all found pieces of the {{setname}} set to found.
      <br />
      <b>This cannot be undone!</b>
    </ui-confirm>
    <ui-confirm autofocus="none" ref="confirmReset" title="Reset Set" @confirm="actionReset">
      This will reset all found pieces of the {{setname}} set to zero.
      <br />
      <b>This cannot be undone!</b>
    </ui-confirm>
    <ui-confirm autofocus="none" ref="confirmArchive" title="Archive Set" @confirm="actionArchive">
      This will archive the {{setname}} set.
      <br />Your progress will be saved, but the set will no longer show on this screen.
      <br />It can be restored using the "Restore Set" function in the main menu.
    </ui-confirm>
    <ui-confirm autofocus="none" ref="confirmDelete" title="Delete Set" @confirm="actionDelete">
      This will delete the {{setname}} set permanently.
      <br />
      <b>Your progress will be lost, and this cannot be undone!</b>
    </ui-confirm>
    <ui-modal ref="contact" title="Contact">
      Email:
      <a href="mailto:brett.whynot@gmail.com">brett.whynot@gmail.com</a>
      <br />Twitter:
      <a href="http://twitter.com/Bre77">@Bre77</a>
    </ui-modal>
    <ui-modal
      ref="donate"
      title="Donate"
    >I am not accepting donations at this time, but feel free to get in contact with your ideas or comments.</ui-modal>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      width: window.innerWidth,
      menu: false,
      add_input: null,
      add_invalid: false,
      add_error: null,
      add_disabled: false,
      sort_input: {
        Parts: localStorage.sort_Parts || "default",
        Sets: localStorage.sort_Sets || "default"
      },
      sort_error: null,
      search_input: null,
      search_error: null,
      menuDefaults: [
        {
          label: "Contact",
          icon: "email"
        },
        {
          label: "Donate",
          icon: "attach_money"
        },
        {
          type: "divider"
        },
        {
          label: "Logout",
          icon: "exit_to_app"
        }
      ]
    };
  },
  computed: {
    title() {
      return this.$root.sets[this.$route.params.set]
        ? this.$route.params.set +
            " " +
            this.$root.sets[this.$route.params.set].name
        : this.$route.name;
    },
    menuOptions() {
      if (this.$route.meta.menu) {
        return this.$route.meta.menu.concat(
          [
            {
              type: "divider"
            }
          ],
          this.menuDefaults
        );
      } else {
        return this.menuDefaults;
      }
    },
    sortOptions() {
      //let trigger = this.sort_input
      let ops = Array.from(this.$route.meta.sort_menu);
      let idx = ops.findIndex(
        x => x.value == this.sort_input[this.$route.name]
      );
      return ops.splice(idx, 1).concat([{ type: "divider" }], ops);
    },
    set() {
      if (
        this.$root.$route.params.set &&
        this.$root.sets[this.$root.$route.params.set]
      ) {
        return this.$root.sets[this.$root.$route.params.set];
      } else {
        return null;
      }
    },
    setname() {
      return this.set ? "'" + this.set.name + "'" : "";
    }
  },
  methods: {
    menuSelect(event) {
      switch (event.label) {
        case "Back":
          this.$router.push({ name: this.$root.$route.meta.parent });
          break;
        case "Move":
          console.log("Move");
          break;
        case "Complete":
          this.$refs["confirmComplete"].open();
          break;
        case "Reset":
          this.$refs["confirmReset"].open();
          break;
        case "Archive":
          this.$refs["confirmArchive"].open();
          break;
        case "Delete":
          this.$refs["confirmDelete"].open();
          break;
        case "Restore Set":
          console.log("Restored");
          break;
        case "Contact":
          this.$refs["contact"].open();
          break;
        case "Donate":
          this.$refs["donate"].open();
          break;
        case "Logout":
          this.$Firebase.auth().signOut();
          break;
      }
      //this.menu = false;
    },
    menuBlur() {
      this.menu = false;
    },
    actionComplete() {
      if (this.$root.$UserRef && this.$root.$route.params.set && this.set) {
        var updates = {};
        for (var key in this.set.parts) {
          updates[key + "/found"] = this.set.parts[key].quantity;
        }
        this.$root.$UserRef
          .child("sets/" + this.$root.$route.params.set + "/parts")
          .update(updates);
      }
    },
    actionReset() {
      if (this.$root.$UserRef && this.$root.$route.params.set && this.set) {
        var updates = {};
        for (var key in this.set.parts) {
          updates[key + "/found"] = 0;
        }
        this.$root.$UserRef
          .child("sets/" + this.$root.$route.params.set + "/parts")
          .update(updates);
      }
    },
    actionArchive() {
      if (this.$root.$UserRef && this.$root.$route.params.set) {
        this.$root.$UserRef
          .child("sets/" + this.$root.$route.params.set + "/archive")
          .set(true);
        this.$router.push("/sets");
      }
    },
    actionDelete() {
      if (this.$root.$UserRef && this.$root.$route.params.set) {
        this.$root.$UserRef
          .child("sets/" + this.$root.$route.params.set)
          .remove();
        this.$router.push("/sets");
      }
    },
    addSubmit(e) {
      this.add_error = "";
      this.add_invalid = false;
      this.add_disabled = true;
      //e.preventDefault()
      if (this.$root.$UserRef) {
        var id = parseInt(this.add_input);
        this.add_disabled = true;

        // Add Placeholder
        this.$set(this.$root.sets, id, {
          set_num: id,
          name: "Loading",
          parts: {},
          found: 0,
          quantity: 1,
          remaining: 1,
          completeness: 0
        });

        this.$root.loading++;
        this.$root.$Load(id).then(
          set => {
            this.$root.loading--;
            console.log("Success");
            this.$root.$UserRef.child("sets/" + id).set({
              added: +new Date(),
              archive: false
            }); //Create an empty object to trigger Firebase
            this.$refs.add.closeDropdown();
          },
          error => {
            this.$root.loading--;
            console.warn(error);
            this.add_disabled = false;
            this.add_invalid = true;
            this.add_error = "Set Not Found";
          }
        );
      } else {
        this.add_invalid = true;
        this.add_error = "Not Logged In";
      }
    },
    addBlur(e) {
      this.add_error = null;
      this.add_invalid = false;
      this.add_input = null;
      this.add_disabled = false;
    },
    backSubmit() {
      this.search_input = null;
      this.$router.push({ name: this.$route.meta.parent });
      this.menuBlur();
    },
    sortSubmit(e) {
      // Trigger a resort even on the same value
      if (this.sort_input[this.$route.name] == e.value) {
        this.$set(this.sort_input, this.$route.name, null);
        this.$nextTick(() => {
          this.$set(this.sort_input, this.$route.name, e.value);
        });
      } else this.$set(this.sort_input, this.$route.name, e.value);
      localStorage[`sort_${this.$route.name}`] = e.value;
      this.$refs.sort.closeDropdown();
    },
    sortBlur(e) {},
    searchSubmit(e) {
      this.$refs.search.closeDropdown();
    },
    searchBlur(e) {}
  },
  mounted() {
    // Windows Resize Listener
    this.$nextTick(function() {
      window.addEventListener("resize", e => {
        this.width = window.innerWidth;
      });
    });
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

body {
  background: rgb(242, 242, 242);
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", Helvetica, Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

#toolbar {
  z-index: 2;
  position: fixed;
  top: 0px;
  width: 100vw;
}

#menu {
  position: fixed;
  z-index: 2;
  width: 217px;
  height: 100%;

  background: rgb(242, 242, 242);
}

.container {
  margin-top: 56px;
  padding: 5px;
  width: 100%;
  height: 100%;
}

.box {
  position: relative;
  margin: 5px;
  border: 1px solid black;
  background-color: white;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.2);
}

.img {
  left: 0;
  right: 0;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}

.txt {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.15s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
}

.ui-ripple-ink__ink {
  background-color: #2196f3;
}
</style>



// WEBPACK FOOTER //
// src/App.vue